import React from 'react'
import Navbar from '../Comman_Layout/Header/Navbar'
import BecomePartnerFormBanner from './BecomePartnerFormBanner'
import BecomePartnerFormField from './BecomePartnerFormField'
import Footer from '../Comman_Layout/Footer/Footer'
import Gotop from '../Comman_Layout/Gotop'

const BecomePartnerForm = () => {
  return (
    <>
    <Navbar/>
    <BecomePartnerFormField/>
    <Footer/>
    <Gotop/>
    </>
  )
}

export default BecomePartnerForm